import type { approvals as en } from "../en/approvals";
import type { Messages } from "../types";

export const approvals: Messages<typeof en> = {
  title: "الموافقات",
  description: "ردود وإجراءات تريد قواعد الأتمتة والمساعد تنفيذها. لا يُرسل شيء قبل موافقتك.",
  tabs: {
    pending: "بالانتظار",
    approved: "تمت الموافقة",
    rejected: "مرفوضة",
  },
  kinds: {
    reply_public: "رد علني",
    reply_private: "رد خاص",
    send_message: "رسالة مباشرة",
    hide: "إخفاء تعليق",
    delete: "حذف تعليق",
    bulk: "إجراء جماعي",
  },
  proposedBy: {
    rule: "قاعدة",
    assistant: "المساعد",
    user: "زميل",
  },
  status: {
    pending: "بالانتظار",
    approved: "تمت الموافقة",
    edited: "تمت الموافقة مع تعديل",
    rejected: "مرفوض",
    expired: "منتهي",
  },
  execution: {
    executed: "نُفّذ",
    failed: "فشل",
    reason: "لم يُرسل: {{reason}}",
  },
  card: {
    original: "الأصل",
    draft: "مسودة الذكاء الاصطناعي",
    draftEdited: "معدّلة",
    reason: "السبب",
    rule: "القاعدة",
    noDraft: "بدون نص: هذا الإجراء لا يرسل رسالة.",
    windowClosed: "نافذة المراسلة مغلقة: سيفشل الإرسال.",
    windowClosedHint: "يسمح إنستغرام بالرد خلال 24 ساعة فقط من آخر رسالة من العميل. انتظر حتى يكتب مجدداً، أو ارفض هذه المسودة.",
    openTarget: "فتح في الوارد",
    expiresIn: "ينتهي خلال {{time}}",
    expired: "منتهي",
    chars_zero: "{{count}} / {{max}}",
    chars_one: "{{count}} / {{max}}",
    chars_two: "{{count}} / {{max}}",
    chars_few: "{{count}} / {{max}}",
    chars_many: "{{count}} / {{max}}",
    chars_other: "{{count}} / {{max}}",
    select: "تحديد",
    reset: "استعادة مسودة الذكاء الاصطناعي",
    more: "إجراءات أخرى",
    openRule: "فتح القاعدة",
    windowClosedAgo: "أغلق إنستغرام هذه المحادثة {{when}}. ردّ عندما يكتب لك مجدداً.",
    windowClosedNow: "أغلق إنستغرام هذه المحادثة. ردّ عندما يكتب لك مجدداً.",
  },
  actions: {
    approve: "موافقة",
    approveEdited: "موافقة على التعديل",
    reject: "رفض",
    approveAll_zero: "موافقة على {{count}}",
    approveAll_one: "موافقة على {{count}}",
    approveAll_two: "موافقة على {{count}}",
    approveAll_few: "موافقة على {{count}}",
    approveAll_many: "موافقة على {{count}}",
    approveAll_other: "موافقة على {{count}}",
    approveSelected: "موافقة على المحدد",
    selectAll: "تحديد الكل",
    approved: "تمت الموافقة والإرسال",
    approvedEdited: "تمت الموافقة على تعديلك وإرساله",
    rejected: "تم الرفض",
    batchDone_zero: "تم إرسال {{count}} موافقة",
    batchDone_one: "تم إرسال موافقة واحدة",
    batchDone_two: "تم إرسال موافقتين",
    batchDone_few: "تم إرسال {{count}} موافقات",
    batchDone_many: "تم إرسال {{count}} موافقة",
    batchDone_other: "تم إرسال {{count}} موافقة",
    failed: "تعذّر تطبيق القرار",
    undoHint: "العناصر الموافق عليها تُرسل فوراً.",
  },
  empty: {
    title: "لا شيء بانتظارك",
    hint: "لا توجد ردود بانتظار موافقتك. ستصل هنا المسودات الجديدة من القواعد التي تتطلب الموافقة.",
    other: "لا شيء هنا بعد",
    otherHint: "تظهر الموافقات المحسومة في هذا التبويب.",
    filteredHint: "لا شيء بالانتظار يطابق هذه التصفية.",
    openRules: "فتح القواعد",
  },
  keyboard: "\u2066J/K\u2069 للتنقل · \u2066A\u2069 موافقة · \u2066R\u2069 رفض · \u2066E\u2069 تعديل",
  count_zero: "{{count}} بالانتظار",
  count_one: "{{count}} بالانتظار",
  count_two: "{{count}} بالانتظار",
  count_few: "{{count}} بالانتظار",
  count_many: "{{count}} بالانتظار",
  count_other: "{{count}} بالانتظار",
  keyboardHint: "⁦J / K⁩ للتنقل · ⁦{{mod}}+Enter⁩ موافقة · ⁦R⁩ رفض · ⁦E⁩ تعديل",
  loadMore: "تحميل المزيد",
  filters: {
    remove: "إزالة التصفية: {{name}}",
  },
  bulk: {
    selected_zero: "لم يُحدد شيء",
    selected_one: "عنصر واحد محدد",
    selected_two: "عنصران محددان",
    selected_few: "{{count}} عناصر محددة",
    selected_many: "{{count}} عنصرًا محددًا",
    selected_other: "{{count}} عنصر محدد",
    approve_zero: "موافقة",
    approve_one: "موافقة على عنصر واحد",
    approve_two: "موافقة على عنصرين",
    approve_few: "موافقة على {{count}} عناصر",
    approve_many: "موافقة على {{count}} عنصرًا",
    approve_other: "موافقة على {{count}} عنصر",
    reject_zero: "رفض",
    reject_one: "رفض عنصر واحد",
    reject_two: "رفض عنصرين",
    reject_few: "رفض {{count}} عناصر",
    reject_many: "رفض {{count}} عنصرًا",
    reject_other: "رفض {{count}} عنصر",
    confirmTitle_zero: "لا شيء للموافقة عليه",
    confirmTitle_one: "الموافقة على عنصر واحد؟",
    confirmTitle_two: "الموافقة على عنصرين؟",
    confirmTitle_few: "الموافقة على {{count}} عناصر؟",
    confirmTitle_many: "الموافقة على {{count}} عنصرًا؟",
    confirmTitle_other: "الموافقة على {{count}} عنصر؟",
    confirmLead: "ستُرسل هذه على إنستغرام فوراً:",
    confirm: "موافقة وإرسال",
    skippedClosed_zero: "لن تُتخطى أي رسالة.",
    skippedClosed_one: "ستُتخطى رسالة واحدة: أغلق إنستغرام تلك المحادثة.",
    skippedClosed_two: "ستُتخطى رسالتان: أغلق إنستغرام تلك المحادثتين.",
    skippedClosed_few: "ستُتخطى {{count}} رسائل: أغلق إنستغرام تلك المحادثات.",
    skippedClosed_many: "ستُتخطى {{count}} رسالة: أغلق إنستغرام تلك المحادثات.",
    skippedClosed_other: "ستُتخطى {{count}} رسالة: أغلق إنستغرام تلك المحادثات.",
    kind: {
      reply_public_zero: "لن يُنشر أي رد علني",
      reply_public_one: "سيُنشر رد علني واحد",
      reply_public_two: "سيُنشر ردّان علنيان",
      reply_public_few: "ستُنشر {{count}} ردود علنية",
      reply_public_many: "سيُنشر {{count}} ردًا علنيًا",
      reply_public_other: "سيُنشر {{count}} رد علني",
      reply_private_zero: "لن يُرسل أي رد خاص",
      reply_private_one: "سيُرسل رد خاص واحد",
      reply_private_two: "سيُرسل ردّان خاصان",
      reply_private_few: "ستُرسل {{count}} ردود خاصة",
      reply_private_many: "سيُرسل {{count}} ردًا خاصًا",
      reply_private_other: "سيُرسل {{count}} رد خاص",
      send_message_zero: "لن تُرسل أي رسالة مباشرة",
      send_message_one: "ستُرسل رسالة مباشرة واحدة",
      send_message_two: "ستُرسل رسالتان مباشرتان",
      send_message_few: "ستُرسل {{count}} رسائل مباشرة",
      send_message_many: "ستُرسل {{count}} رسالة مباشرة",
      send_message_other: "ستُرسل {{count}} رسالة مباشرة",
      hide_zero: "لن يُخفى أي تعليق",
      hide_one: "سيُخفى تعليق واحد",
      hide_two: "سيُخفى تعليقان",
      hide_few: "ستُخفى {{count}} تعليقات",
      hide_many: "سيُخفى {{count}} تعليقًا",
      hide_other: "سيُخفى {{count}} تعليق",
      delete_zero: "لن يُحذف أي تعليق",
      delete_one: "سيُحذف تعليق واحد",
      delete_two: "سيُحذف تعليقان",
      delete_few: "ستُحذف {{count}} تعليقات",
      delete_many: "سيُحذف {{count}} تعليقًا",
      delete_other: "سيُحذف {{count}} تعليق",
      bulk_zero: "لن يُنفّذ أي إجراء جماعي",
      bulk_one: "سيُنفّذ إجراء جماعي واحد",
      bulk_two: "سيُنفّذ إجراءان جماعيان",
      bulk_few: "ستُنفّذ {{count}} إجراءات جماعية",
      bulk_many: "سيُنفّذ {{count}} إجراءً جماعيًا",
      bulk_other: "سيُنفّذ {{count}} إجراء جماعي",
    },
  },
  likelihood: {
    veryLikely: "مرجّح جداً",
    likely: "مرجّح",
    possibly: "محتمل",
  },
  reasons: {
    withLikelihood: "{{reason}}، {{likelihood}}",
    negative: "تعليق سلبي",
    positive: "تعليق إيجابي",
    spam: "رسائل مزعجة",
    hate: "خطاب كراهية",
    complaint: "شكوى",
    question: "سؤال",
    price: "سؤال عن السعر",
    agent: "اقتراح من الوكيل الذكي",
    promotion: "يحتوي على ترويج",
    assistantSpam: "طلبت من المساعد تنظيف الرسائل المزعجة",
  },
};
